import { inject, Injectable } from '@angular/core';
import { Observable, map, catchError, throwError } from 'rxjs';
import { NotifyService } from '@src/app/shared/services/notiflix/notify.service';
import { iApiResponse } from '@src/app/core/interfaces/iApiResponse';
import { AuthPermissionApi } from '../Apis/auth-permission.api';
import { MenuDataApi } from '../Apis/menu.data.api';

@Injectable({
  providedIn: 'root'
})
export class CountDataMenuAction {

  private service = inject(MenuDataApi);
  private notifyService = inject(NotifyService);

  execute(branch_uuid:string): Observable<iApiResponse> {
    return this.service.countMenuData(branch_uuid).pipe(
      map(response => response),
      catchError(err => {
      this.notifyService.error(err.error?.error?.message ?? err.message)
        return throwError(() => err);
      }),
    );
  }
}
